import Component from '../core/Component'
import EventBus from '../core/EventBus'
import {EVENTS} from '../core/Events'
import { queryAll } from '../utils/dom'

export const STATES = {}
export const EMITS = {}

//stara se o highlight spravnyho radku s mistnosti po otevreni modalu
export default class Places extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            dragTable: null
        }
    }

    prepare() {
        this.dragTable = Component.getFromElement(this.ref.dragTable)

        EventBus.on(EVENTS.MODAL_OPEN,this.handleModalOpen)
        EventBus.on(EVENTS.MODALOPENER_CLICK,this.handleModalOpenerClick)
    }

    handleModalOpen = () => {
        setTimeout(() => {
            this.dragTable.resize()
        }, 0)
    }

    handleModalOpenerClick = data => {
        const placeId = data.element.dataset.placeId

        if (!placeId) {
            return
        }

        const placeElements = queryAll(`[data-place-id]`, this.dragTable.element)

        placeElements.forEach(element => {
            if (element.dataset.placeId === placeId) {
                element.classList.add('is-highlighted')
            } else {
                element.classList.remove('is-highlighted')
            }
        })
    }

}